<template>
  <v-container fluid grid-list-xl fill-height>
    <v-layout justify-center align-center>
      <v-flex xs12>
        <material-card color="green">
          <div slot="header">
            <div class="title font-weight-light mb-2">
              Alerts and Notifications
            </div>
            <div class="category">
              {{ new Date().toLocaleString() }}
            </div>
          </div>

          <v-card-text>
            <v-layout row wrap>
              <v-flex md6 sm12>
                <h2 class="title">New Alerts:</h2>
                <h3 class="text-xs-center" v-if="!alerts.length > 0">
                  <br />
                  No new Notifications
                </h3>
                <div v-for="(alert, i) in alerts" :key="i">
                  <material-notification
                    class="mb-3"
                    color="warning"
                    icon="mdi-bell-plus"
                  >
                    <v-layout>
                      <v-flex md10 sm10>
                        <!-- {{ alert }} -->
                        <p>
                          {{ new Date(alert.createdDate).toLocaleString() }}
                        </p>
                        <p>
                          {{ alert.description }}
                        </p>
                      </v-flex>
                      <v-flex md2 sm2>
                        <v-btn flat v-on="on" @click="close(alert, i)">
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </material-notification>
                </div>
              </v-flex>

              <v-flex md6 sm12>
                <h2 class="title">Resolved Alerts:</h2>
                <h3 class="text-xs-center" v-if="!alertsResolved.length > 0">
                  <br />
                  No new Notifications
                </h3>

                <div v-for="(alert, i) in alertsResolved" :key="i">
                  <material-notification class="mb-3" color="success">
                    <v-layout>
                      <v-flex md10 sm10>
                        <!-- {{ alert }} -->
                        <p>
                          {{ new Date(alert.createdDate).toLocaleString() }}
                        </p>
                        <p>
                          {{ alert.description }}
                        </p>
                      </v-flex>
                      <v-flex md2 sm2>
                        <!-- <v-btn flat v-on="on" @click="close(alert, i)">
                          <v-icon>mdi-close</v-icon>
                        </v-btn> -->
                      </v-flex>
                    </v-layout>
                  </material-notification>
                </div>

                <!-- <material-notification class="mb-3" color="warning" dismissible>
                  <strong>WARNING</strong> - This is a regular notification made
                  with `color="warning"`
                </material-notification> -->

                <!-- <material-notification class="mb-3" color="error" dismissible>
                  <strong>DANGER</strong> - This is a regular notification made
                  with `color="error"`
                </material-notification> -->

                <!-- <material-notification class="mb-3" color="purple" dismissible>
                  <strong>PRIMARY</strong> - This is a regular notification made
                  with `color="purple"`
                </material-notification> -->
              </v-flex>
            </v-layout>
          </v-card-text>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axiosApi from "../axios-api";

export default {
  data: () => ({
    alerts: [],
    alertsResolved: [],
    color: null,
    colors: ["purple", "info", "success", "warning", "error"],
    top: true,
    bottom: false,
    left: false,
    right: false,
    snackbar: false,
  }),
  mounted() {
    if (this.$store.state.alerts.length > 0) {
      this.alerts = this.$store.state.alerts;
      this.alerts.reverse();
    }

    if (this.$store.state.alertsResolved.length > 0) {
      this.alertsResolved = this.$store.state.alertsResolved;
      this.alertsResolved.reverse();
    }
  },
  methods: {
    // snack (...args) {
    //   this.top = false
    //   this.bottom = false
    //   this.left = false
    //   this.right = false
    //   for (const loc of args) {
    //     this[loc] = true
    //   }
    //   this.color = this.colors[Math.floor(Math.random() * this.colors.length)]
    //   this.snackbar = true
    // }
    close(event, i) {
      // console.log(event)
      // alert(event.id)

      axiosApi
        .put(`/alert/${event.id}`)
        .then((response) => {
          console.log(response);
          if (response.status == 200) {
            this.alerts.remove = function(index) {
              this.splice(index, 1);
            };
            this.alertsResolved.push(this.alerts[i]);
            this.alerts.remove(i);
          }
        });
    },
  },
};
</script>
